import { type FC, useEffect, useMemo } from 'react';
import { motion, useSpring, useTransform } from 'motion/react';
import { clsx } from '@team/clsx';
import { Transformer, type Props } from './types';
import css from './style.module.css';

const defaultSpringOptions = {
  stiffness: 100,
  damping: 30,
  mass: 0.5,
  bounce: 0,
};

const defaultTransformer: Transformer = (current) =>
  Math.round(current).toLocaleString();

export const Entry: FC<Props> = ({
  value,
  className,
  springOptions = defaultSpringOptions,
  Component = 'span',
  transformer = defaultTransformer,
}) => {
  const MotionComponent = useMemo(() => motion.create(Component), [Component]);

  const spring = useSpring(value, springOptions);
  const display = useTransform(spring, transformer);

  useEffect(() => {
    spring.set(value);
  }, [spring, value]);

  return (
    <MotionComponent className={clsx(className, css.root)}>
      {display}
    </MotionComponent>
  );
};
